import React from 'react';
import { ChatSessionContext } from './chatSessionContext';
import { useChatSession } from './useChatSession';
import type { ChatSessionFactory } from './sessionFactory';

interface ChatSessionProviderProps {
  children: React.ReactNode;
  // Overridden by tests and the local mock harness to stand in for ChatJS.
  sessionFactory?: ChatSessionFactory;
}

export const ChatSessionProvider: React.FC<ChatSessionProviderProps> = ({ children, sessionFactory }) => {
  const chat = useChatSession(sessionFactory);
  return <ChatSessionContext.Provider value={chat}>{children}</ChatSessionContext.Provider>;
};
